import Navbar from "./navbar";
import About from "./About";
import Banner from "./sections/banner";
import Skills from "./sections/skills";
import Services from "./sections/services";
import Projects from "./sections/projects";
import Contact from "./sections/contact";
import BlogSection from "./sections/blogSection";
import Newsletter from "../components/Newsletter";
import Footer from "./sections/footer";
import SEO from "../components/SEO";

export default function Home() {
  return (
    <div className="m-0 p-0 bg-white ">
      <SEO 
        title="Full Stack Developer & Designer"
        description="Welcome to Frantzley's portfolio. Discover modern web development, UI design projects, and insightful blog articles."
      />
      <Navbar />
      <Banner />
      <About />
      <Skills />
      <Services />
      <Projects />
      <Contact />
      <BlogSection />
      <Newsletter />
      <Footer />
    </div>
  );
}
